import type { StatusNoErp } from '../../api/aberturas.js';
import { ChipStatus } from '../../componentes/ChipStatus.js';
import { resumoNoErp } from './situacao-da-abertura.js';
import './ResumoNoErp.css';

/**
 * Onde as entregas de uma movimentação estão no caminho até o ERP.
 *
 * Um chip por estado que tem entrega — rejeitada e retida primeiro, porque
 * são as que alguém precisa olhar. Sem entrega, a célula diz isso em vez de
 * ficar vazia, que se leria como falha de carga.
 */
export function ResumoNoErp({ status }: { readonly status: StatusNoErp }) {
  const partes = resumoNoErp(status);

  if (partes.length === 0) {
    return <span className="resumo-erp__vazio">Sem entregas</span>;
  }

  return (
    <ul className="resumo-erp">
      {partes.map((parte) => (
        <li key={parte.estado}>
          <ChipStatus tom={parte.tom} rotulo={parte.rotulo} tamanho="tabela" />
        </li>
      ))}
    </ul>
  );
}
